const focusAreas = [
  {
    label: "Video in retail",
    link_url: "/category/video-in-retail",
  },
  {
    label: "Self-checkout",
    link_url: "/category/self-checkout",
  },
  {
    label: "Food waste",
    link_url: "/category/food-waste-and-markdowns",
  },
  {
    label: "RFID in retail",
    link_url: "/category/rfid",
  },
  {
    label: "E-commerce loss",
    link_url: "/category/ecommerce-loss",
  },
  {
    label: "Retail loss, safety and security",
    link_url: "/category/retail-loss",
  },
  {
    label: "Inventory accuracy",
    link_url: "/category/inventory-accuracy",
  },
  {
    label: "On-shelf availability",
    link_url: "/category/on-shelf-availability",
  },
]

export { focusAreas }
